/* eslint-disable no-empty */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import s from './SiteSync.scss';

const SiteSync = ({ config }) => {
  const [loadIFrame, setFrameLoaded] = useState(false);
  const [isScrolled, setScrolled] = useState(false);
  const [iframeStyle, setIframeStyle] = useState({});
  const [barStyle, setBarStyle] = useState({});
  const [scrollTimeOut, setscrollTimeOut] = useState(0);
  const iframeWidth = 1100;
  const scrollReset = () => {
    document.querySelector('body, html').scroll({
      left: 0,
      behavior: 'smooth',
    });
    if (scrollTimeOut) clearTimeout(scrollTimeOut);
    setScrolled(false);
  };

  const scrollLg = () => {
    if (document.querySelector('body, html').scrollTop < 10) {
      document.querySelector('body, html').scroll({
        left: iframeWidth,
        behavior: 'smooth',
      });
    } else {
      document.querySelector('body, html').scroll({
        top: 0,
        left: iframeWidth,
        behavior: 'smooth',
      });
    }
    setScrolled(true);
  };

  const onSwitchBarClick = event => {
    event.preventDefault();
    if (isScrolled) {
      scrollReset();
    } else {
      scrollLg();
    }
  };

  const getDocumentSize = () => {
    const height = window.innerHeight || document.documentElement.clientHeight;
    const width = window.innerWidth || document.documentElement.clientWidth;
    return { width, height };
  };
  /*
    Setting position on right for site sync 
  */
  const onPosition = (docWidth, docHeight) => {
    const wrapper = document.querySelector('.contentwrapper');
    const mainContentWrapperWidth = (wrapper?.offsetWidth || 1168) + 20; // wrapper width  // 1168px //1020
    const switchBarWidth = 35; // bar width
    const wWidth = docWidth;
    const blankSpace = (wWidth - mainContentWrapperWidth) / 2;
    const rightEdgePos = blankSpace - switchBarWidth;
    const iright = `-${iframeWidth - rightEdgePos}px`;
    const barImgId = `https://static.toiimg.com/photo/${config.barImgId}.cms`;
    setBarStyle(prev => ({
      ...prev,
      right: rightEdgePos,
      height: docHeight,
      backgroundImage: `url(${barImgId})`,
    }));
    setIframeStyle(prev => ({ ...prev, right: iright }));
  };

  const initiateFlash = () => {
    scrollLg();
    setscrollTimeOut(
      setTimeout(() => {
        scrollReset();
      }, config.autoflash),
    );
  };

  const onLoadIframe = docHeight => {
    setBarStyle(prev => ({
      ...prev,
      cursor: 'pointer',
      height: docHeight,
      // display: 'block',
    }));
    setIframeStyle(prev => ({
      ...prev,
      minHeight: docHeight,
      // display: 'block',
    }));
    if (config.autoflash) {
      setTimeout(() => {
        initiateFlash();
      }, 1000);
    }
  };

  const removeGutterCls = () => {
    try {
      const body = document.querySelector('body');
      body.classList.remove('bgImg');
    } catch (e) {}
  };

  const init = () => {
    removeGutterCls();
    const { width, height } = getDocumentSize();
    onPosition(width, height);
    setFrameLoaded(true);
  };

  useEffect(() => {
    init();
  }, []);

  return (
    config.siteUrl && (
      <div className="siteSyncWrapper">
        <div id="frameHolder" className={s.frameHolder} style={iframeStyle}>
          {loadIFrame && (
            <iframe
              title="Sync Site"
              src={config.siteUrl}
              width={iframeWidth}
              height={5803}
              scrolling="no"
              frameBorder={0}
              onLoad={() => {
                onLoadIframe();
              }}
            />
          )}
        </div>
        <div
          className={s.switchBar}
          onClick={ev => onSwitchBarClick(ev)}
          style={barStyle}
        />
        {config.pixel1_1 && (
          <img alt="none" src={config.pixel1_1} width="1" height="1" />
        )}
      </div>
    )
  );
};

SiteSync.propTypes = {
  config: PropTypes.shape({
    siteUrl: PropTypes.string,
    autoflash: PropTypes.string,
    barImgId: PropTypes.string,
    pixel1_1: PropTypes.string,
  }),
};

SiteSync.defaultProps = {
  config: {
    siteUrl: '',
    autoflash: '',
    barImgId: '',
    pixel1_1: '',
  },
};

export default SiteSync;
